<template>
  <footer class="footer">
    <div class="container-large">
      <div class="top-content">
        <nav class="holder-footer-nav">
          <ul class="footer-nav">
            <li>
              <router-link
                id="footer_get_support"
                class="footer-navbar-link footer-navbar-link-mod"
                :to="{ path: '/get-support' }"
              >
                Get support
              </router-link>
            </li>
            <li>
              <router-link
                id="footer_faq"
                class="footer-navbar-link footer-navbar-link-mod"
                :to="{ path: '/faq' }"
              >
                FAQ
              </router-link>
            </li>
            <li>
              <router-link
                id="footer_terms"
                class="footer-navbar-link footer-navbar-link-mod"
                :to="{ path: '/terms-Of-conditions' }"
              >
                Terms of conditions
              </router-link>
            </li>
            <li>
              <router-link
                id="footer_privacy"
                class="footer-navbar-link footer-navbar-link-mod"
                :to="{ path: '/privacy-policy' }"
              >
                Privacy Policy
              </router-link>
            </li>
            <li>
              <router-link
                id="footer_cookie"
                class="footer-navbar-link footer-navbar-link-mod"
                :to="{ path: '/cookie-policy' }"
              >
                Cookie Policy
              </router-link>
            </li>
            <li>
              <router-link
                id="footer_accessibility"
                class="footer-navbar-link footer-navbar-link-mod"
                :to="{ path: '/accessibility-policy' }"
              >
                Accessibility Policy
              </router-link>
            </li>
            <!--              <li>-->
            <!--                <router-link-->
            <!--                  v-if="login"-->
            <!--                  id="footer_app_version"-->
            <!--                  class="footer-navbar-link footer-navbar-link-mod"-->
            <!--                  :to="{ path: '/app-version' }"-->
            <!--                >App Versions-->
            <!--                </router-link>-->
            <!--              </li>-->
          </ul>
        </nav>
        <div class="logo">
          <LogoIconBlue />
        </div>
      </div>
      <div class="bottom-content">
        <div class="copyryght">
          <p>&copy; 1996-2024, PME.com, Inc. or its affiliates</p>
        </div>
        <div class="social">
          <a
            id="social_fb"
            :href="facebook"
            target="_blank"
            class="social-link"
          >
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M27.9375 0.9375H2.0625C1.44023 0.9375 0.9375 1.44023 0.9375 2.0625V27.9375C0.9375 28.5598 1.44023 29.0625 2.0625 29.0625H27.9375C28.5598 29.0625 29.0625 28.5598 29.0625 27.9375V2.0625C29.0625 1.44023 28.5598 0.9375 27.9375 0.9375ZM24.6891 9.14648H22.4426C20.6812 9.14648 20.3402 9.9832 20.3402 11.2137V13.9242H24.5449L23.9965 18.1676H20.3402V29.0625H15.9563V18.1711H12.2895V13.9242H15.9563V10.7953C15.9563 7.16367 18.1746 5.18438 21.416 5.18438C22.9699 5.18438 24.3023 5.30039 24.6926 5.35313V9.14648H24.6891Z" />
            </svg>
          </a>
          <a
            id="social_tw"
            :href="linkedIn"
            target="_blank"
            class="social-link"
          >
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M27.375 0.375H2.625C2.02826 0.375 1.45597 0.612053 1.03401 1.03401C0.612053 1.45597 0.375 2.02826 0.375 2.625V27.375C0.375 27.9717 0.612053 28.544 1.03401 28.966C1.45597 29.3879 2.02826 29.625 2.625 29.625H27.375C27.9717 29.625 28.544 29.3879 28.966 28.966C29.3879 28.544 29.625 27.9717 29.625 27.375V2.625C29.625 2.02826 29.3879 1.45597 28.966 1.03401C28.544 0.612053 27.9717 0.375 27.375 0.375ZM10.5 21.75C10.5 22.0484 10.3815 22.3345 10.1705 22.5455C9.95952 22.7565 9.67337 22.875 9.375 22.875C9.07663 22.875 8.79048 22.7565 8.5795 22.5455C8.36853 22.3345 8.25 22.0484 8.25 21.75V12.75C8.25 12.4516 8.36853 12.1655 8.5795 11.9545C8.79048 11.7435 9.07663 11.625 9.375 11.625C9.67337 11.625 9.95952 11.7435 10.1705 11.9545C10.3815 12.1655 10.5 12.4516 10.5 12.75V21.75ZM9.375 10.5C9.04124 10.5 8.71498 10.401 8.43748 10.2156C8.15997 10.0302 7.94368 9.76663 7.81595 9.45828C7.68823 9.14993 7.65481 8.81063 7.71992 8.48328C7.78504 8.15594 7.94576 7.85526 8.18176 7.61926C8.41776 7.38326 8.71844 7.22254 9.04578 7.15742C9.37313 7.09231 9.71243 7.12573 10.0208 7.25345C10.3291 7.38118 10.5927 7.59747 10.7781 7.87498C10.9635 8.15248 11.0625 8.47874 11.0625 8.8125C11.0625 9.26005 10.8847 9.68928 10.5682 10.0057C10.2518 10.3222 9.82255 10.5 9.375 10.5ZM22.875 21.75C22.875 22.0484 22.7565 22.3345 22.5455 22.5455C22.3345 22.7565 22.0484 22.875 21.75 22.875C21.4516 22.875 21.1655 22.7565 20.9545 22.5455C20.7435 22.3345 20.625 22.0484 20.625 21.75V16.6875C20.625 15.9416 20.3287 15.2262 19.8012 14.6988C19.2738 14.1713 18.5584 13.875 17.8125 13.875C17.0666 13.875 16.3512 14.1713 15.8238 14.6988C15.2963 15.2262 15 15.9416 15 16.6875V21.75C15 22.0484 14.8815 22.3345 14.6705 22.5455C14.4595 22.7565 14.1734 22.875 13.875 22.875C13.5766 22.875 13.2905 22.7565 13.0795 22.5455C12.8685 22.3345 12.75 22.0484 12.75 21.75V12.75C12.7514 12.4744 12.8539 12.209 13.038 12.004C13.2222 11.7989 13.4751 11.6686 13.749 11.6378C14.0228 11.6069 14.2984 11.6776 14.5236 11.8365C14.7487 11.9954 14.9078 12.2314 14.9705 12.4997C15.7315 11.9834 16.6188 11.6842 17.5371 11.6342C18.4554 11.5841 19.3699 11.7852 20.1825 12.2157C20.9952 12.6462 21.6752 13.29 22.1495 14.0778C22.6239 14.8657 22.8747 15.7679 22.875 16.6875V21.75Z" fill="#8692A6" />
            </svg>
          </a>
          <a
            id="social_insta"
            :href="instagram"
            target="_blank"
            class="social-link"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill=""
            >
              <path d="M31.4211 12.4577C31.406 11.3216 31.1933 10.1968 30.7926 9.13368C30.4451 8.23691 29.9144 7.42248 29.2343 6.74243C28.5543 6.06237 27.7399 5.53166 26.8431 5.18418C25.7936 4.79022 24.6849 4.57719 23.5641 4.55418C22.1211 4.48968 21.6636 4.47168 18.0006 4.47168C14.3376 4.47168 13.8681 4.47168 12.4356 4.55418C11.3153 4.57736 10.2071 4.79038 9.15809 5.18418C8.26118 5.53141 7.44663 6.06205 6.76654 6.74213C6.08646 7.42221 5.55583 8.23677 5.20859 9.13368C4.81384 10.1824 4.60128 11.2908 4.58009 12.4112C4.51559 13.8557 4.49609 14.3132 4.49609 17.9762C4.49609 21.6392 4.49609 22.1072 4.58009 23.5412C4.60259 24.6632 4.81409 25.7702 5.20859 26.8217C5.55641 27.7183 6.08744 28.5326 6.76775 29.2123C7.44806 29.8921 8.26269 30.4225 9.15959 30.7697C10.2057 31.1795 11.3142 31.4078 12.4371 31.4447C13.8816 31.5092 14.3391 31.5287 18.0021 31.5287C21.6651 31.5287 22.1346 31.5287 23.5671 31.4447C24.6878 31.4226 25.7966 31.2101 26.8461 30.8162C27.7426 30.4683 28.5569 29.9374 29.2369 29.2574C29.9169 28.5774 30.4477 27.7632 30.7956 26.8667C31.1901 25.8167 31.4016 24.7097 31.4241 23.5862C31.4886 22.1432 31.5081 21.6857 31.5081 18.0212C31.5051 14.3582 31.5051 13.8932 31.4211 12.4577ZM17.9916 24.9032C14.1606 24.9032 11.0571 21.7997 11.0571 17.9687C11.0571 14.1377 14.1606 11.0342 17.9916 11.0342C19.8307 11.0342 21.5946 11.7648 22.895 13.0652C24.1955 14.3657 24.9261 16.1295 24.9261 17.9687C24.9261 19.8078 24.1955 21.5716 22.895 22.8721C21.5946 24.1726 19.8307 24.9032 17.9916 24.9032ZM25.2021 12.3947C24.3066 12.3947 23.5851 11.6717 23.5851 10.7777C23.5851 10.5654 23.6269 10.3553 23.7081 10.1592C23.7893 9.96308 23.9084 9.7849 24.0585 9.63482C24.2086 9.48474 24.3867 9.36568 24.5828 9.28446C24.7789 9.20324 24.9891 9.16143 25.2013 9.16143C25.4136 9.16143 25.6238 9.20324 25.8199 9.28446C26.0159 9.36568 26.1941 9.48474 26.3442 9.63482C26.4943 9.7849 26.6133 9.96308 26.6946 10.1592C26.7758 10.3553 26.8176 10.5654 26.8176 10.7777C26.8176 11.6717 26.0946 12.3947 25.2021 12.3947Z" />
              <path d="M17.9908 22.4729C20.4786 22.4729 22.4953 20.4561 22.4953 17.9684C22.4953 15.4806 20.4786 13.4639 17.9908 13.4639C15.5031 13.4639 13.4863 15.4806 13.4863 17.9684C13.4863 20.4561 15.5031 22.4729 17.9908 22.4729Z" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import login from '@/mixins/login';
import LocalStorageService from '../services/LocalStorageService';
import LogoIconBlue from '@/components/icons/LogoIconBlue.vue';
const localStorageService = LocalStorageService.getService();

export default {
  name: 'Footer',
  components: {
    LogoIconBlue,
  },
  mixins: [login],
  data() {
    return {
      twitter: '',
      linkedIn: '',
      facebook: '',
      instagram: ''
    };
  },
  created() {
    if(!this.$store.state.authentication.status.loggedIn) {
      localStorageService.clearToken();
    }
    this.$load(async() => {
      let response = (await this.$api.socialLinks.getSocialLinks());
      this.linkedIn = response.data.body.linkedIn;
      this.facebook = response.data.body.facebook;
      this.instagram = response.data.body.instagram;
    });
  },
};
</script>

<style scoped>
footer {
  display: flex;
  flex-direction: column;
}
.holder-footer-nav {
  width: 80%;
  display: flex;
  justify-content: space-between;
}
.footer-nav {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
}
.footer-nav li {
  padding: 10px 50px 40px 0px;
}
.footer-nav li a {
  text-decoration: none;
  color: var(--secondary-black-color);
  font-size: 16px;
  font-weight: 700;
}
.footer-nav li a:hover {
   transition: all 0.2s ease;
   color: var(--black-color);
 }
.top-content {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--input-placeholder-value-color);
  margin-bottom: 25px;
}
.bottom-content {
  display: flex;
  justify-content: space-between;
  margin-bottom: 35px;
}
.bottom-content p {
  color: var(--input-placeholder-value-color);
  font-size: 16px;
  font-weight: 400;
}
.social {
  display: flex;
  align-items: center;
  margin: 0 -10px;
}
.social a {
  margin-right: 25px;
}
.social a:last-child {
  margin: 0;
}
footer .social svg path {
  fill: var(--secondary-text-color);
}
footer .social svg:hover path {
  transition: all 0.2s ease;
  fill: var(--accent-color);
}
</style>